import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../style/NavBar.css';

const NavBar = () => {
    const paths = [
        { path: '/', label: 'Главная' },
        { path: '/about', label: 'О компании' },
        { path: '/contacts', label: 'Контакты' },
        { path: '/profile-page', label: 'Профиль' }
    ];

    return (
        <motion.header
            className="navbar"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
        >
            <motion.div
                className="logo"
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300 }}
            >
                🚗 ROAD ASSIST
            </motion.div>

            <nav className="nav-links">
                {paths.map(({ path, label }) => (
                    <motion.div
                        key={path}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        transition={{ type: 'spring', stiffness: 300 }}
                    >
                        <Link to={path}>
                            {label}
                        </Link>
                    </motion.div>
                ))}
            </nav>
        </motion.header>
    );
};

export default NavBar;
